import * as S from "./HistoryList.style";
import { memo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, HistoryDetails } from "components";
import { tableHead, formatTableData } from "pages/HistoryPage/HistoryPage.config";
import { getChatMessages } from "redux_toolkit/reducers/history/historySlice";


export const HistoryList = memo(({
  setSelectedRowIndex,
  setHistoryDetailsItem,
  partnerId,
  selectedRowIndex,
  historyDetailsItem,
  historyList,
  notFound
})=> {
  const [bodyMaxHeight, setBodyMaxHeight] = useState('');
  const styles = S.useStyles({ bodyMaxHeight });
  const dispatch = useDispatch();
  const selectedChatIdRef = useRef(null);

  const { messagesList } = useSelector(({history})=> history);

  // History-only: size tbody to the History box so all rows are reachable by inner scroll
  useEffect(() => {
    const updateHeight = () => {
      const pageEl = document.getElementById('historyPage');
      const tableTopEl = document.getElementById('tableTop');
      const wrapEl = document.getElementById('history-table-wrap');
      if (!pageEl || !tableTopEl) return;

      const pageBottom = pageEl.getBoundingClientRect().bottom;
      const filtersBottom = tableTopEl.getBoundingClientRect().bottom;
      const theadEl = wrapEl?.querySelector('thead');
      const theadHeight = theadEl?.getBoundingClientRect().height || 56;
      // space between filters and page bottom, minus table margin + thead + small card padding
      const tableMargin = 20;
      const cardPad = 8;
      const available = pageBottom - filtersBottom - tableMargin - theadHeight - cardPad;
      setBodyMaxHeight(`${Math.max(160, Math.floor(available))}px`);
    };

    updateHeight();
    const raf = requestAnimationFrame(updateHeight);
    window.addEventListener('resize', updateHeight);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', updateHeight);
    };
  }, [historyList]);

  return(
    <S.TableContainer id="history-table-wrap">
      <S.TableCardWrap>
        <Table
          tableHead={tableHead}
          selectedRowIndex={selectedRowIndex}
          onRowClick={(item, index) => {
            setSelectedRowIndex(index);
            selectedChatIdRef.current = item._id;
            const cached = messagesList.get(item._id);
            const cachedMessages = Array.isArray(cached) ? cached : cached?.data;
            const cachedLogs = Array.isArray(cached) ? undefined : cached?.logs;

            if (cachedMessages && cachedLogs !== undefined) {
              setHistoryDetailsItem({ ...item, messages: cachedMessages, logs: cachedLogs });
              return;
            }

            dispatch(getChatMessages({ partnerId, chatId: item._id })).then((res) => {
              if (res.meta?.requestStatus !== 'fulfilled' || !res.payload) return;
              if (res.payload.chatId !== selectedChatIdRef.current) return;
              setHistoryDetailsItem({
                ...item,
                messages: res.payload.data,
                logs: res.payload.logs || [],
              });
            });
          }}
          tbodyClassName={styles.tbody}
          theadClassName={styles.thead}
          tableData={formatTableData(historyList)}
          notFound={notFound}
          allScreen={true}
        />
      </S.TableCardWrap>
      {!!historyDetailsItem && historyDetailsItem?.messages && (
        <HistoryDetails
          partnerId={partnerId}
          item={historyDetailsItem}
          visitorPartner={historyDetailsItem.visitorPartner?.[0]?.user || {name: historyDetailsItem.visitorName}}
          onClose={() => {
            setHistoryDetailsItem(null);
            setSelectedRowIndex(-1);
          }}
        />
      )}
    </S.TableContainer>
  )
}, (prevProps, nextProps)=> {
  return(
    prevProps.setHistoryDetailsItem === nextProps.setHistoryDetailsItem &&
    prevProps.setSelectedRowIndex === nextProps.setSelectedRowIndex &&
    prevProps.partnerId === nextProps.partnerId &&
    prevProps.selectedRowIndex === nextProps.selectedRowIndex &&
    prevProps.historyDetailsItem === nextProps.historyDetailsItem &&
    prevProps.historyList === nextProps.historyList &&
    prevProps.notFound === nextProps.notFound
  );
})